module.exports = __webpack_public_path__ + "img/fauna_n.d5c23edb.png";